import { graphql } from 'graphql-schema';

const GET_RENTAL_PERKS = graphql(`
  query rental($rentalId: uuid!) {
    rental: rentals_by_pk(_id: $rentalId) {
      _id
      perks {
        _id
        perk
      }
      custom_perks
    }
  }
`);

export default GET_RENTAL_PERKS;
